import { render, staticRenderFns } from "./ai-assistant-icon.vue?vue&type=template&id=4c9521e9"
import script from "./ai-assistant-icon.vue?vue&type=script&lang=js"
export * from "./ai-assistant-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports